import { render, staticRenderFns } from "./OrderPartsNew.vue?vue&type=template&id=ade4e154&"
import script from "./OrderPartsNew.vue?vue&type=script&lang=ts&"
export * from "./OrderPartsNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports